export function renderTable(ctx, shape, ptScale) {
    if (!shape.table) {
        renderPlaceholder(ctx, shape, ptScale);
        return;
    }
    const table = shape.table;
    const startX = shape.position.x * ptScale;
    const startY = shape.position.y * ptScale;
    const colWidths = table.columnWidths.map(w => w * ptScale);
    let currentY = startY;
    for (const row of table.rows) {
        const rowHeight = row.height * ptScale;
        let currentX = startX;
        for (let colIdx = 0; colIdx < row.cells.length; colIdx++) {
            const cell = row.cells[colIdx];
            const cellWidth = colWidths[colIdx] || 100 * ptScale;
            if (cell.fill) {
                ctx.fillStyle = typeof cell.fill === 'string' ? cell.fill : '#CCCCCC';
                ctx.fillRect(currentX, currentY, cellWidth, rowHeight);
            }
            ctx.strokeStyle = '#000000';
            ctx.lineWidth = 0.5;
            ctx.strokeRect(currentX, currentY, cellWidth, rowHeight);
            if (cell.text && cell.text.trim() !== '') {
                const margins = cell.margins || { left: 7.5, right: 7.5, top: 7.5, bottom: 0 };
                const textX = currentX + (margins.left * ptScale);
                const textY = currentY + (margins.top * ptScale);
                const textWidth = cellWidth - ((margins.left + margins.right) * ptScale);
                const textHeight = rowHeight - ((margins.top + margins.bottom) * ptScale);
                const style = cell.textStyle || {};
                const fontSize = (style.fontSize || 14) * ptScale;
                const fontFamily = style.fontFamily || 'Calibri';
                const bold = style.bold;
                const italic = style.italic;
                const fontWeight = bold ? 'bold' : 'normal';
                const fontStyle = italic ? 'italic' : 'normal';
                ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
                const color = style.color;
                ctx.fillStyle = (typeof color === 'string' ? color : '#000000');
                const align = style.align || 'left';
                if (align === 'center') {
                    ctx.textAlign = 'center';
                }
                else if (align === 'right') {
                    ctx.textAlign = 'right';
                }
                else {
                    ctx.textAlign = 'left';
                }
                const vAnchor = cell.verticalAnchor || 'bottom';
                if (vAnchor === 'middle') {
                    ctx.textBaseline = 'middle';
                }
                else if (vAnchor === 'top') {
                    ctx.textBaseline = 'top';
                }
                else {
                    ctx.textBaseline = 'bottom';
                }
                let drawX = textX;
                if (align === 'center') {
                    drawX = textX + textWidth / 2;
                }
                else if (align === 'right') {
                    drawX = textX + textWidth;
                }
                let drawY = textY;
                if (vAnchor === 'middle') {
                    drawY = textY + textHeight / 2;
                }
                else if (vAnchor === 'bottom') {
                    drawY = textY + textHeight;
                }
                ctx.fillText(cell.text, drawX, drawY, textWidth);
            }
            currentX += cellWidth;
        }
        currentY += rowHeight;
    }
}
function renderPlaceholder(ctx, shape, ptScale) {
    const x = shape.position.x * ptScale;
    const y = shape.position.y * ptScale;
    const width = shape.size.width * ptScale;
    const height = shape.size.height * ptScale;
    ctx.fillStyle = '#f8f9fa';
    ctx.fillRect(x, y, width, height);
    ctx.strokeStyle = '#dee2e6';
    ctx.lineWidth = 2;
    ctx.strokeRect(x, y, width, height);
    ctx.strokeStyle = '#adb5bd';
    ctx.lineWidth = 1;
    for (let i = 1; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(x, y + (height / 3) * i);
        ctx.lineTo(x + width, y + (height / 3) * i);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(x + (width / 3) * i, y);
        ctx.lineTo(x + (width / 3) * i, y + height);
        ctx.stroke();
    }
    ctx.fillStyle = '#666666';
    ctx.font = `${12 * ptScale}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('Table', x + width / 2, y + height / 2);
}
//# sourceMappingURL=table.js.map